import { Group, Label, Root, Value } from '@radix-ui/react-select';
import { cn } from 'cn';

import SelectContent from './ui.select-content';
import SelectItem from './ui.select-item';
import SelectScrollDownButton from './ui.select-scroll-down-button';
import SelectScrollUpButton from './ui.select-scroll-up-button';
import SelectSeparator from './ui.select-separator';
import SelectTrigger from './ui.select-trigger';

/**
 * @deprecated Use `Select` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
const Select = Root;

/**
 * @deprecated Use `SelectGroup` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
const SelectGroup = Group;

/**
 * @deprecated Use `SelectValue` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
const SelectValue = Value;

interface SelectLabelProps extends React.ComponentPropsWithoutRef<
  typeof Label
> {
  ref?: React.Ref<React.ElementRef<typeof Label>>;
}

/**
 * @deprecated Use `SelectLabel` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
function SelectLabel({ className, ref, ...props }: SelectLabelProps) {
  return (
    <Label
      ref={ref}
      data-test='select-label'
      className={cn('py-1.5 pr-2 pl-8 text-sm font-semibold', className)}
      {...props}
    />
  );
}

export {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
};
